// `/c/{slug}/setup` (the Setup layout's index, the rail's mode URL: apps/web README decision 43).
// SETUP-REGROUP: it was a redirect to General; it is now the Setup home, every Setup page by
// group with its description and a search (features/settings/setup-home.tsx). Who may see Setup
// is still the layout's ModeGate.
import { createRoute } from "@tanstack/react-router";
import { SetupHome } from "../features/settings/setup-home";
import { useCompany } from "../features/use-feature";
import { setupRoute } from "./c.$slug.setup";

export const settingsRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "/",
  component: function SetupIndex() {
    return <SetupHome company={useCompany()} />;
  },
});
